/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".ui.menu[_ngcontent-%COMP%]{margin-top:0;margin-bottom:0;background:#3e4e69;overflow-x:auto}.ui.menu[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{height:30px;width:auto;margin-right:3px}.ui.menu[_ngcontent-%COMP%]   #login[_ngcontent-%COMP%]   img[_ngcontent-%COMP%]{border-radius:15%;margin-bottom:-10px;margin-top:-10px;margin-right:11px}"];
export { styles as styles };
